import PropTypes from 'prop-types';
import {I18n, Translate} from 'react-redux-i18n';
import {useSelector, useDispatch} from 'react-redux';

import {Icon, stringUtils} from 'front-onceforall-core';
import {COUNTRY} from 'front-onceforall-core/dist/utils/country';

import appConfig from '../../../../config';
import {recordGAEvent} from '../../../utils/analytics';
import {togglePandaBox} from '../../../actions/project';
import {PROJECT_STATUS} from '../../../utils/constant';
import {pathResolver} from '../../../utils/basePathHelper';

function PandaBox({project}) {
  const {projectId, country, projectStatus, ownerOrganisation} = project;
  const dispatch = useDispatch();
  const [organisationId, {showPandaBox = true}] = useSelector(
    ({project: stateProject, organisation}) => [
      organisation.organisationId,
      stateProject[projectId] || {}
    ]
  );

  const isProjectOwner = ownerOrganisation.organisationId === organisationId;

  if (
    !showPandaBox || !isProjectOwner ||
    country !== COUNTRY.FRANCE ||
    projectStatus !== PROJECT_STATUS.ACTIVE
  ) {
    return null;
  }

  return (
    <div
      className='background-white p-4 mx-0 my-5 row justify-content-between align-items-center'
    >
      <img
        alt="logo panda"
        src={pathResolver('resources/img/logo_panda.png')}
        style={{width: '100%', maxWidth: 230}}
        className="col-4"
      />
      <div className="d-flex flex-column col-6">
        {stringUtils.getStrongs(I18n.t('panda.discover.text1'))}
        {I18n.t('panda.discover.text2')}
      </div>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href={appConfig.discoverPanDaUrl}
      >
        <button
          type="button"
          className="large secondary inline-container  mr-n4"
          onClick={() => {
            recordGAEvent('PanDa', 'Discover PanDa');
          }}
        >
          <Translate value="panda.discover.cta"/>
        </button>
      </a>
      <button
        type="button"
        onClick={() => dispatch(togglePandaBox(projectId))}
      >
        <Icon
          tooltip={I18n.t('panda.discover.cancel')}
          className="col-1 mr-4"
          icon="rounded-cross"
          size={35}
        />
      </button>
    </div>
  );
}

PandaBox.propTypes = {
  project: PropTypes.shape({
    projectId: PropTypes.number.isRequired,
    country: PropTypes.string.isRequired,
    projectStatus: PropTypes.oneOf(Object.values(PROJECT_STATUS)).isRequired,
    ownerOrganisation: PropTypes.shape({
      organisationId: PropTypes.number.isRequired
    }).isRequired
  }).isRequired
};

export default PandaBox;
